<template>
    <div class="kgr-inputGroup">
        <hr class="kgr-separator" />
        <kgr-form-row
            :label="$t('Prüfungsdatum')"
            :error="error"
            field-name="examDate"
            required
        >
            <kgr-date-picker
                v-model.trim="result.examDate"
                @enter="onKeyUpEnter"
            />
        </kgr-form-row>
        <kgr-form-row
            :label="$t('Anmerkung')"
            :error="error"
            field-name="note"
        >
            <textarea
                v-model.trim="result.note"
                type="text"
                class="kgr-input"
                @keyup.enter="onKeyUpEnter"
            ></textarea>
        </kgr-form-row>
        <kgr-form-row
            :label="$t('club.exam.result.status')"
            :error="error"
            field-name="status"
        >
            <kgr-generic-radio
                v-model="result.status"
                name="resultStatus"
                :options="statusOptions"
            />
        </kgr-form-row>
        <h2
            v-if="result.examPartResults.length > 0"
            class="kgr-headline kgr-headline--h2 kgr-headline--text"
        >
            {{ $t('Teilergebnisse') }}
        </h2>
        <kgr-exam-part-result-form
            v-for="part in result.examPartResults"
            :key="part.id"
            :exam-part-result="part"
            :error="error"
        />
    </div>
</template>

<script>
import DatePicker from '../common/form/picker/DatePicker.vue';
import Error from '../../js/model/Error.js';
import ExamPartResultForm from './ExamPartResultForm.vue';
import ExamResult from '../../js/dto/club/ExamResult.js';
import FormRow from '../common/form/FormRow.vue';
import GenericRadio from '../common/form/radio/GenericRadio.vue';

export default {
    components: {
        'kgr-generic-radio': GenericRadio,
        'kgr-form-row': FormRow,
        'kgr-date-picker': DatePicker,
        'kgr-exam-part-result-form': ExamPartResultForm,
    },
    props: {
        examResult: {
            type: ExamResult,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    data() {
        return {
            result: this.examResult,
            statusOptions: {
                'club.exam.result.status.success': 'success',
                'club.exam.result.status.failure': 'failure',
            },
        };
    },
    watch: {
        result: {
            handler(value) {
                this.$emit('input', value);
                this.$nextTick(() => {
                    this.$emit('post-input', value);
                });
            },
            deep: true
        }
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
